"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCQLIntervalEndpoints = exports.execute = void 0;
var cql_execution_1 = require("cql-execution");
var ValueSetHelper_1 = require("./ValueSetHelper");
var MeasureBundleHelpers = __importStar(require("../helpers/MeasureBundleHelpers"));
var Enums_1 = require("../types/Enums");
var DetailedResultsBuilder_1 = require("../calculation/DetailedResultsBuilder");
var ValueSetResolver_1 = require("./ValueSetResolver");
var CustomErrors_1 = require("../types/errors/CustomErrors");
function execute(measureBundle, patientSource, options, valueSetCache, debugObject) {
    var _a, _b;
    if (valueSetCache === void 0) { valueSetCache = []; }
    return __awaiter(this, void 0, void 0, function () {
        var measure, valueSets, newCache, missingVS, vsr, _c, expansions, errorMessages, vsMap, _d, cqls, rootLibIdentifier, elmJSONs, _e, startCql, endCql, codeService, parameters, executionDateTime, rep, lib, executor, results;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    measure = MeasureBundleHelpers.extractMeasureFromBundle(measureBundle);
                    valueSets = [];
                    newCache = [];
                    missingVS = ValueSetHelper_1.getMissingDependentValuesets(measureBundle, __spreadArrays(valueSetCache));
                    if (!(missingVS.length > 0)) return [3 /*break*/, 2];
                    if (!options.vsAPIKey || options.vsAPIKey.length == 0) {
                        throw new CustomErrors_1.UnexpectedResource("Missing the following valuesets: " + missingVS.join(', ') + ", and no API key was provided to resolve them");
                    }
                    vsr = new ValueSetResolver_1.ValueSetResolver(options.vsAPIKey || '');
                    return [4 /*yield*/, vsr.getExpansionForValuesetUrls(missingVS)];
                case 1:
                    _c = _f.sent(), expansions = _c[0], errorMessages = _c[1];
                    if (errorMessages.length > 0) {
                        throw new Error(errorMessages.join('\n'));
                    }
                    valueSets.push.apply(valueSets, expansions);
                    // Update cache to include new expansions
                    if (options.useValueSetCaching) {
                        newCache.push.apply(newCache, expansions);
                    }
                    _f.label = 2;
                case 2:
                    (_a = measureBundle.entry) === null || _a === void 0 ? void 0 : _a.forEach(function (e) {
                        var _a;
                        if (((_a = e.resource) === null || _a === void 0 ? void 0 : _a.resourceType) === 'ValueSet') {
                            valueSets.push(e.resource);
                        }
                    });
                    // Include provided ValueSets in code service
                    // These can be provided directly as an argument or via the caching behavior
                    valueSets.push.apply(valueSets, valueSetCache);
                    vsMap = ValueSetHelper_1.valueSetsForCodeService(valueSets);
                    _d = MeasureBundleHelpers.extractLibrariesFromBundle(measureBundle), cqls = _d.cqls, rootLibIdentifier = _d.rootLibIdentifier, elmJSONs = _d.elmJSONs;
                    _e = getCQLIntervalEndpoints(options), startCql = _e.startCql, endCql = _e.endCql;
                    // add expressions for collecting for all measure observations
                    (_b = measure.group) === null || _b === void 0 ? void 0 : _b.forEach(function (group) {
                        var _a, _b;
                        (_b = (_a = group.population) === null || _a === void 0 ? void 0 : _a.filter(function (population) { return MeasureBundleHelpers.codeableConceptToPopulationType(population.code) === Enums_1.PopulationType.OBSERV; })) === null || _b === void 0 ? void 0 : _b.forEach(function (obsrvPop) {
                            var _a, _b, _c;
                            var msrPop = (_a = group.population) === null || _a === void 0 ? void 0 : _a.find(function (population) { return MeasureBundleHelpers.codeableConceptToPopulationType(population.code) === Enums_1.PopulationType.MSRPOPL; });
                            if (((_b = msrPop === null || msrPop === void 0 ? void 0 : msrPop.criteria) === null || _b === void 0 ? void 0 : _b.expression) && ((_c = obsrvPop.criteria) === null || _c === void 0 ? void 0 : _c.expression)) {
                                var mainLib = elmJSONs.find(function (elm) { return elm.library.identifier.id === rootLibIdentifier.id; });
                                if (mainLib) {
                                    mainLib.library.statements.def.push(DetailedResultsBuilder_1.generateELMJSONFunction(obsrvPop.criteria.expression, msrPop.criteria.expression));
                                }
                            }
                        });
                    });
                    codeService = new cql_execution_1.CodeService(vsMap);
                    parameters = { 'Measurement Period': new cql_execution_1.Interval(startCql, endCql) };
                    executionDateTime = cql_execution_1.DateTime.fromJSDate(new Date(), 0);
                    rep = new cql_execution_1.Repository(elmJSONs);
                    lib = rep.resolve(rootLibIdentifier.id, rootLibIdentifier.version);
                    executor = new cql_execution_1.Executor(lib, codeService, parameters);
                    return [4 /*yield*/, executor.exec(patientSource, executionDateTime)];
                case 3:
                    results = _f.sent();
                    // Map evaluated resource from engine to the raw FHIR json
                    Object.keys(results.patientEvaluatedRecords).forEach(function (patientId) {
                        results.patientEvaluatedRecords[patientId] = results.patientEvaluatedRecords[patientId].map(function (r) { return r._json; });
                    });
                    if (debugObject && options.enableDebugOutput) {
                        debugObject.elm = elmJSONs;
                        debugObject.cql = cqls;
                        debugObject.vs = vsMap;
                        debugObject.rawResults = results;
                    }
                    return [2 /*return*/, __assign({ rawResults: results, elmLibraries: elmJSONs, mainLibraryName: rootLibIdentifier.id, parameters: parameters }, (options.useValueSetCaching && { valueSetCache: newCache }))];
            }
        });
    });
}
exports.execute = execute;
/**
 * Takes in the calculation options and returns start and end dates to create a cql interval
 * @param options calculationOptions passed in by the user
 * @returns {startCql: Date, endCql: Date}, the start and end date of the calculationOptions
 */
function getCQLIntervalEndpoints(options) {
    // Measure datetime stuff
    var start;
    var end;
    if (options.measurementPeriodStart) {
        start = ValueSetHelper_1.parseTimeStringAsUTC(options.measurementPeriodStart);
    }
    else {
        start = new Date('2019-01-01');
    }
    if (options.measurementPeriodEnd) {
        end = ValueSetHelper_1.parseTimeStringAsUTC(options.measurementPeriodEnd);
    }
    else {
        end = new Date('2019-12-31');
    }
    var startCql = cql_execution_1.DateTime.fromJSDate(start, 0); // No timezone offset for start
    var endCql = cql_execution_1.DateTime.fromJSDate(end, 0); // No timezone offset for stop
    return { startCql: startCql, endCql: endCql };
}
exports.getCQLIntervalEndpoints = getCQLIntervalEndpoints;
//# sourceMappingURL=Execution.js.map